import { store as auth } from '@/modules/auth';
import { store as layout } from '@/modules/layout';
import { store as cadastro } from '@/pages/dashboard/cadastro';
import { store as meusBoletos } from '@/pages/dashboard/meusBoletos';
import { store as meusContratos } from '@/pages/dashboard/meusContratos';
import { store as propostas } from '@/pages/dashboard/propostas';
import { store as propostasCdc } from '@/pages/dashboard/propostasCdc';
import { store as propostasConsorcio } from '@/pages/dashboard/propostasConsorcio';
import { store as propostasContencioso } from '@/pages/dashboard/propostasContencioso';
import { store as propostasFianca } from '@/pages/dashboard/propostasFianca';
import utm from '@/store/modules/utm';

export default {
    auth,
    layout,
    cadastro,
    meusBoletos,
    meusContratos,
    propostas,
    propostasCdc,
    propostasConsorcio,
    propostasContencioso,
    propostasFianca,
    utm,
}
